export const startUpCarousel = true

